module.exports = __webpack_public_path__ + "img/logo-ccnb.b1ffe909.jpg";